import React from 'react';
import L from 'leaflet';
import { Pane } from 'evergreen-ui';
import { mapsLayers, mapsTile } from 'Utils/Maps/mapsLayers';
import MapViewSelector from './MapViewSelector';
import MapViewDatasourceFilterSelector from './MapViewDatasourceFilterSelector';
import MapViewGeoJSONCheckbox from './MapViewGeoJSONCheckbox';
import MapViewEnableClusteringCheckbox from './MapViewEnableClusteringCheckbox';
import MapViewMeasureSelector from './MapViewMeasureSelector';
import MapViewCommonMeteocodesLoader from './MapViewCommonMeteocodesLoader';

export default function HomeSidebarContent({ mapInstance }: { mapInstance: L.Map | null }) {
  return (
    <Pane padding=".5rem">
      <MapViewDatasourceFilterSelector />
      <MapViewCommonMeteocodesLoader />
      <MapViewMeasureSelector />
      <MapViewSelector
        mapInstance={mapInstance}
        layers={mapsTile}
        label="Подложка"
        defaultValue="Open Street Map"
      />
      <MapViewSelector
        mapInstance={mapInstance}
        layers={mapsLayers}
        label="Слой"
        hasNoneValue
        defaultValue="none"
      />
      <MapViewGeoJSONCheckbox />
      <MapViewEnableClusteringCheckbox />
    </Pane>
  );
}
